import { useLocation } from 'react-router-dom';
import useSWR from 'swr';
import { trpc } from '../config/trpc';

export function useContractorInvite() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get('invite-token');
  const { data, isLoading, error, isValidating } = useSWR<{
    invitedOrgEmail: string;
    invitedOrgName: string;
  }>(
    {
      token,
    },
    async () =>
      trpc.onboard.getContractorInvite.query({ inviteToken: token ?? '' })
  );
  return {
    data,
    isLoading,
    error,
    isValidating,
    createOrg: async ({ firstName, lastName, password, orgName, email }) =>
      trpc.onboard.createContractorAdmin.mutate({
        email,
        orgName,
        password,
        firstName,
        lastName,
        inviteToken: token ?? '',
      }),
  };
}
